module.exports = __webpack_public_path__ + "img/dishes_placeholder.6bd69f41.svg";